import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/config';
import { applyTheme, applyDesignTokens } from './shared/theme/themes';
import { checkAppVersion, startAppVersionWatcher } from '@minibook/shared/client/ensureFreshVersion';
import { initYandexMetrika } from '@minibook/shared/client/yandexMetrika';
import { initBookingVisualViewport } from './shared/lib/bookingVisualViewport';
import { setupProductionConsole } from './shared/lib/devLog';
import { initSentryBrowser } from '@minibook/shared/client/sentryBrowser';

setupProductionConsole();
initSentryBrowser();

applyDesignTokens();
applyTheme('light');

async function boot() {
  // PWA / вкладка: при новом деплое version.json меняется → reload до рендера, без «мигания» старого UI
  if (!import.meta.env.DEV) {
    try {
      const reloaded = await checkAppVersion(import.meta.env.VITE_GIT_COMMIT || '');
      if (reloaded) return;
    } catch {
      /* сеть недоступна — грузим текущий бандл */
    }
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  initBookingVisualViewport();

  initYandexMetrika();
  startAppVersionWatcher(import.meta.env.VITE_GIT_COMMIT || '');
}

void boot();
